module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp12_1.ae324463.png";